// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"49db80f3","41":"4287e06d","50":"1449ec0f","145":"b92985eb","233":"3164a58b","343":"4ec8f246","544":"ac878be4","658":"556153d1","678":"dd34f2f6","783":"41430917","980":"ef3e4ce5"}[chunkId] + ".chunk.js";
};